export default {
    TOP_BAR_HEIGHT: 65
};
